import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { Video } from '@/types'
import { DUMMY_VIDEOS } from '@/lib/dummyData'

export function useVideos(limit?: number) {
  const [videos, setVideos] = useState<Video[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let q = supabase.from('videos').select('*').order('created_at', { ascending: false })
    if (limit) q = q.limit(limit)
    q.then(({ data, error }) => {
      const rows = !error && data && data.length > 0 ? data : DUMMY_VIDEOS
      setVideos(limit ? rows.slice(0, limit) : rows)
      setLoading(false)
    })
  }, [limit])

  return { videos, loading }
}
